<template>
    <div class="copyright" :style="`backgroundColor:${templateBackground};paddingBottom: ${!btn_show ? '10PX' : ''};paddingTop: 10PX`">
        <div  v-if="tid == 1">
            河北易之行网络科技有限公司<br />
            CopyRight © 2017 YixingAuto.com All Rights Reserved<br />
            冀ICP备17016416号-1
        </div>
        <div v-else-if="tid == 2">
            山东赤兔文化传媒有限公司<br />
            CopyRight © 2017 ChituAuto.com All Rights Reserved<br />
            鲁ICP备18035235号-3
        </div>
        <div v-else-if="tid == 3">
            河北果然好信息技术有限公司<br />
            CopyRight © 2024 grhesc.com All Rights Reserved<br />
            冀ICP备2024057716号-1
        </div>
    </div>
</template>

<script>
    import getUrlKey from "../utils/_geturl";
    import _geturl from "../utils/_geturl";

    export default {
        name: "copyright",
        data(){
            return{
                tid: 1, //1-易行；2-赤兔
                templateBackground: '#fff'
            }
        },

        props: {
            templateBackgroundColor:{
                type: String,
            },
            btn_show: {
                type: Boolean
            }
        },
        created() {
            let base_url = window.location.host;
            // console.log(base_url)
            if (base_url.indexOf("chitu") != -1){
                this.tid = 2
            }
            if (base_url.indexOf("grhesc") != -1){
                this.tid = 3
            }
        }
    }
</script>

<style scoped lang="less">
    @import "../assets/style/common/copyright";
</style>
